export const QUESTIONS_TYPE = {
  DEFAULT: 'question',
  RATE: 'rate',
  SCORE_RATE: 'score-rate',
  DARK: 'dark',
  EFFECTIVE_EXERCISES: 'effective-exercises',
  KEGEL_BENEFITS: 'kegel-plan-benefits',
  KEGEL_EFFECTIVENESS: 'kegel-effectiveness',
  GOALS: 'goals',
  GOALS_REVIEWS: 'pp1',
  s1: 's1',
  proof1: 'proof1',
  proof12: 'proof12',
  proof2: 'proof2',
  proof3: 'proof3',
  proof4: 'proof4',
  proof43: 'proof4-3',
  proof5: 'proof5',
  proof: 'proof',
  PERSONAL_PLAN: 'personal-plan',
  INTERMEDIATE: 'intermediate',
  ANIMATION: 'animation',
};
